// component
import PageTitle from "components/molecules/PageTitle/PageTitle";
import { useRejectRetrospectiveClaim } from "containers/RejectRetrospectiveClaim/useRejectRetrospectiveClaim";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import { Head } from "components/molecules/Head/Head";
import Spinner from "components/atoms/Spinner/Spinner";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";

// ANT modules
import { Form, Input } from "antd";

// styles
import styles from "containers/RejectRetrospectiveClaim/rejectRetrospectiveClaim.module.css";

// constants
import { PageTitles, RejectRetroClaim as Constants } from "constants/global";

// Utils
import getIconOthers from "utils/getIconRetrospectiveClaim";

const { TextArea } = Input;

const buttonTypeClass = (isActive: boolean, isReasonValid: boolean) => {
	if (isActive && isReasonValid) {
		return "active";
	}
	return "disabled";
};

type ErrorMessageWrapperTypes = {
	fieldError?: boolean;
	message: string;
};

const ErrorMessageWrapper = ({ fieldError, message }: ErrorMessageWrapperTypes) => {
	return fieldError ? <ErrorMessage classes={styles?.err_message} message={message} /> : <></>;
};

const RejectRetrospectiveClaim = () => {
	const componentProps = useRejectRetrospectiveClaim();
	const { isReasonValid, goBack, proceedToConfirm, inputValue, handleInput, validateReason, loading } = componentProps;

	const textCls = inputValue?.input && isReasonValid ? styles?.basic_input_active : styles?.err;

	return (
		<div>
			<div className={styles?.root}>
				{loading && <Spinner type="transparent" />}
				<div className={styles?.bg_curve}>{getIconOthers({ icon: "background" })}</div>
				<div className={styles?.bg_frame}>{getIconOthers({ icon: "overlay" })}</div>
				<Head>{PageTitles.REJECT_CLAIM}</Head>
				<PageTitle showBackIcon={true} title={Constants.REJECT_CLAIM_HEADER} subTitle={Constants.REVIEW_RETRO_CLAIM_SUBHEADER} goBack={goBack} />
				<div className={styles?.main_wrapper}>
					<Form className={styles?.form} layout="vertical">
						<div className={styles?.input_wrapper}>
							<Form.Item
								extra={<ErrorMessageWrapper message={Constants.INVALID_REJECTION_ERR} fieldError={!!inputValue?.input && !isReasonValid} />}
								name={Constants.FIELD_REASON_LABEL}
								label={<Label classes={{ label: styles?.basic_input_label }} label={Constants.REASON_LABEL} />}
							>
								<TextArea
									value={inputValue.input}
									data-testid={Constants.FIELD_REASON_LABEL}
									onChange={(e) => handleInput(e.target?.value)}
									onBlur={(e) => validateReason?.(e.target?.value)}
									className={!inputValue.input ? styles?.basic_input : textCls}
									rows={9}
								/>
							</Form.Item>
						</div>
						<div className={styles?.buttons_wrapper}>
							<Button onClick={proceedToConfirm} type={buttonTypeClass(inputValue.active, isReasonValid)} background="red" label={Constants.REJECT_BUTTON} />
							<Button type="active" background="white" label={Constants.GOBACK_BUTTON} onClick={goBack} />
						</div>
					</Form>
				</div>
			</div>
		</div>
	);
};

export default RejectRetrospectiveClaim;
